// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"9598ab76","191":"c32dfec3","226":"8f7aca6a","311":"528533d1","376":"a75eed76","437":"21e9b08c","488":"63e8f9c5","995":"4a83d21f"}[chunkId] + ".chunk.js";
};